import { AddressViewModel, AffinityDelivery, AffinityProduct, GetQuoteStep, LastPurchased, PriceOptionViewModel, ProductModelX, ProductViewModel, QuantityViewModel } from "@affinity/Store/StoreTypes";
import { Category } from "@insite/client-framework/Services/CategoryService";
import { ProductModel, ProductPriceDto, ShipToModel } from "@insite/client-framework/Types/ApiModels";

export type GetQuoteState = Readonly<{
    currentStep: GetQuoteStep; 
    productRegular: ProductModel | undefined;
    productPremium: ProductModel | undefined;
    quantityRegular: QuantityViewModel | undefined;
    quantityPremium: QuantityViewModel | undefined;
    deliveryCheapest: PriceOptionViewModel | undefined;
    deliverySoonest: PriceOptionViewModel | undefined;
    stepValues: Record<GetQuoteStep, string | undefined> | undefined;
    hasAttemped: boolean;

    // NEW
    selectedProduct: AffinityProduct;
    postcode: string;
    emailAddress: string;
    allowMarketing: boolean;
    quantity: number | undefined;
    selectedDelivery: AffinityDelivery;
    targetUrl: string | undefined;
    isInitialised: boolean;
}>;

export const initialState: GetQuoteState = {
    currentStep: GetQuoteStep.BasicDetails,
    productRegular: undefined,
    productPremium: undefined,
    quantityRegular: undefined,
    quantityPremium: undefined,
    stepValues: undefined,
    deliveryCheapest: undefined,
    deliverySoonest: undefined,
    hasAttemped: false,

    // NEW
    selectedProduct: AffinityProduct.Regular,
    postcode: "",
    emailAddress: "",
    allowMarketing: false,
    quantity: undefined,
    selectedDelivery: AffinityDelivery.Cheapest,
    targetUrl: undefined,
    isInitialised: false
};

export default GetQuoteState;